import React, {useState} from 'react';
import useStyles from "../../../assets/styles/ProgramRatingStyles";
import {
    Container,
    Typography,
    Grid,
    Box,
    Button
} from '@material-ui/core';
import LoaderWithBackDrop from "../../../components/LoaderWithBackDrop/LoaderWithBackDrop.comp";
import { APP_STATUS } from "../../../utils/constants";
import {Dialog, DialogContent, DialogContentText, DialogTitle} from "@mui/material";

const RatingAssessmentWelcomeView = ({ options, actions, data }) => {
    const classes = useStyles();
    const { loading} = options;
    const {accessAssessmentAction } = actions;
    const { application_id, status} = data;



    const handleAccessAssessment = () => {
        accessAssessmentAction(application_id, status);
    };

    const navigateToAssessmentSelection = () => {
        accessAssessmentAction(application_id, status);
    };

    return (
        <>
            {status === APP_STATUS.READY_TO_CERTIFY ? (
                <Container className={classes.assessmentContainer}>
                    <Container className={classes.assessmentContainer} style={{ paddingTop: '40px' }}>
                        <Typography component="h1" className={classes.title} variant="h5" style={{ fontWeight: "bold", textAlign: "center" }}>
                            Welcome to DQ Assessment Creator
                        </Typography>
                        <Typography variant="body1" sx={{ padding: { sm: '10px 150px', xs: '0px' } }} style={{ fontSize: '29px', textAlign: "center", color: '#ff6468' }}>
                            Build Assessments to Measure Learner Performance and Program Impact
                        </Typography>
                        <Typography sx={{ marginTop: 3, padding: { sm: '10px 150px', xs: '0px' } }} style={{ lineHeight: '1.2', fontWeight: 'normal', marginTop: '30px', fontSize: '17px', padding: '10px 155px', textAlign: "left" }}>
                            Design high-quality digital citizenship assessments—standardized or customized—aligned with global research and benchmarking data to measure both learner outcomes and overall program effectiveness.
                        </Typography>
                        <br />
                        <Typography sx={{ marginTop: 2, padding: { sm: '10px 150px', xs: '0px' }, marginBottom: '30px' }} style={{ lineHeight: '1.2', fontWeight: 'normal', fontSize: '17px', padding: '10px 155px', textAlign: "left" }}>
                            You'll receive a ready-to-use <strong>assessment tool</strong> and an integrated <strong>data analytics dashboard</strong> linked to the <strong>CPCI Index</strong>, the global benchmark for child online safety and digital citizenship impact.
                        </Typography>
                        <Grid container className={classes.sectionContainer}>
                            <Grid item className={classes.sectionItem}>
                                <Typography component="h1" variant="h2"
                                            style={{ textAlign: 'center', paddingTop: '20px', fontWeight: 'bold', margin: '20px 0px', fontSize: '32px' }}>
                                    Assessment
                                </Typography>
                                <Typography component="h1" variant="h5" style={{ textAlign: 'center', padding: '10px 30px', color: "#ED6628", fontSize: '20px' }}>
                                    Customized assessments to measure learners' digital citizenship — delivered via mobile, web, or API.
                                </Typography>
                                <ul style={{ fontSize: '16px', textAlign: 'left', marginTop: '20px' }}>
                                    <li>Scorecards benchmarked against global standards
                                    </li>
                                    <li>White-label option available for brand consistency
                                    </li>
                                </ul>
                            </Grid>
                            <Grid item className={classes.sectionItem}>
                                <Typography component="h1" variant="h2"
                                            style={{ textAlign: 'center', paddingTop:'20px',fontWeight: 'bold', margin: '20px 0px', fontSize: '32px' }}>
                                    Analytics Dashboard
                                </Typography>
                                <Typography component="h1" variant="h5" style={{ textAlign: 'center',padding:'10px 30px', color: "#ED6628", fontSize: '20px' }}>
                                Real-time insights to track program reach and impact.
                                </Typography>
                                <ul style={{ fontSize: '16px', textAlign: 'left', marginTop: '40px' }}>
                                    <li>Monitor digital literacy levels and improvement rates
                                    </li>
                                    <li>Filter by region, age, gender, and socioeconomic status
                                    </li>
                                    <li>Benchmark against data from 100+ countries
                                    </li>
                                </ul>
                            </Grid>
                        </Grid>
                    </Container>
                    <Button
                        variant="contained"
                        color="primary"
                        className={classes.button}
                        onClick={navigateToAssessmentSelection}
                        style={{ backgroundColor: "#052F44", color: "white", borderRadius: "15px" }}
                    >
                        Next
                    </Button>
                    <LoaderWithBackDrop loading={loading} />
                </Container>
            )  : (
                            <Typography
                                component="h1"
                                variant="h5"
                                style={{ fontWeight: "bold", textAlign: "center" }}
                            >
                                Your application is currently under review. You will receive an email notification once the assessment has been finalized.
                            </Typography>
            )}

        </>
    );
};

export default RatingAssessmentWelcomeView;
